import { Box } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * The top-level component for the auth pages.
 *
 * This component renders the logo absolutely positioned at the top right of the
 * screen, and then renders the Outlet component from react-router-dom, which
 * will render the current auth page.
 *
 * @returns The Auth component.
 */
const Auth: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        position: 'relative',
      }}
    >
      <Outlet />
    </Box>
  );
};

export default Auth;
